// Generated by BUCKLESCRIPT VERSION 2.0.0, PLEASE EDIT WITH CARE
'use strict';

var App                             = require("./App");
var ReactDOMRe                      = require("reason-react/lib/js/src/ReactDOMRe.js");
var ReasonReact                     = require("reason-react/lib/js/src/ReasonReact.js");
var $dot$slashregisterServiceWorker = require("./registerServiceWorker");

ReactDOMRe.renderToElementWithId(ReasonReact.element(/* None */0, /* None */0, App.make(/* array */[])), "root");

$dot$slashregisterServiceWorker.default();

/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/index.re
// module id = 30
// module chunks = 0